<template lang="pug">
  .history-label
    .form-section
      .history-container
        .history-label(:class="color") Version
        div {{ dataOriginal.version }}
      .history-container
        .history-label(:class="color") {{ capitalize(dataOriginal.transaction) }}d by
        shNameUser(v-if="dataOriginal.transaction === 'create'" :dni="dataOriginal.createdBy")
        shNameUser(v-else :dni="dataOriginal.updatedBy")
      .history-container(v-if="dataOriginal.width")
        .history-label Width
        div {{ dataOriginal.width }}
      .history-container(v-if="dataOriginal.height")
        .history-label Height
        div {{ dataOriginal.height }}
      .history-container(v-if="dataOriginal.quantity")
        .history-label Quantity
        div {{ dataOriginal.quantity }}
      .history-container(v-if="dataOriginal.containerWidth")
        .history-label Container Width
        div {{ dataOriginal.containerWidth }}
      .history-container(v-if="dataOriginal.padding")
        .history-label Padding
        div {{ dataOriginal.padding }}
</template>

<script>
import mFilters from '@/mixins/filters'
import shNameUser from '@/components/elements/NameUser'

export default {
  name: 'HistoryUser',

  mixins: [mFilters],

  components: { shNameUser },

  props: {
    dataOriginal: Object,
    color: String
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/label/History.vue